import { TimeZoneContext } from 'context/common/TimeZoneContext'
import { useContext } from 'react'
import { dateFormats } from 'constants/common'

export const isNextOpeningSlotToday = (nextSlot: ProviderSlot): boolean => {
  const { format } = useContext(TimeZoneContext)
  const formattedSlot = format(nextSlot?.start, dateFormats.MONTH_DATE_FORMAT)
  const formattedTodaysDate = format(new Date(), dateFormats.MONTH_DATE_FORMAT)
  return formattedSlot === formattedTodaysDate
}
